import { render, staticRenderFns } from "./Mergers.vue?vue&type=template&id=1efc89a8&scoped=true"
import script from "./Mergers.vue?vue&type=script&lang=js"
export * from "./Mergers.vue?vue&type=script&lang=js"
import style0 from "./Mergers.vue?vue&type=style&index=0&id=1efc89a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efc89a8",
  null
  
)

export default component.exports